import { render, staticRenderFns } from "./checkBoxOn.vue?vue&type=template&id=d2c2d942&"
import script from "./checkBoxOn.vue?vue&type=script&lang=ts&"
export * from "./checkBoxOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports